import { I18n } from './I18n';
import { domReady } from './DomReady';
import { initMenu } from './Menu';
import { initSearchToggler } from './SearchToggler';
import { initParallax } from './Parallax';
// import { initZoomBanner } from "./HeroBanner"; // not needed for annual report
import { initNumberAnimation } from './NumberAnimation';
import { initAnchorScroll } from './Anchor';
import { initScrollHeader } from './StickyHeader';
import { initExpandables } from './Expandable';
import { initCarousels } from './Carousel';
import { initSearchPage } from './Search';
import { initFilter } from './Filter';
import { initLikesCounter } from './LikesCounter';
import { initTeaserSliders } from './TeaserSlider';
import { initVideos } from './Video';
import { initVideoiFrame } from './VideoTeaser';
import { initColcades } from './colcade';
import { addRoleButtonListener, appendHintToExternalLinkTitles, formatAge, getResourceUrl, jsCheck, loadScript, tabbingClass } from './Utils';
import { initPlaylist } from './Playlist';
import { initWaterfall } from './Waterfall';
import { initSocialmediaWall } from './SocialmediaWall';
import { initScrollTop } from './ScrollTop';
import { initMostViewed } from './MostViewed';
import { initScrollEvents } from './ScrollEvents';
import { initTrafficNewsFilter } from './TrafficNewsFilter';
import { initTrafficNewsRss } from './TrafficNewsRss';
import { initDescriptionToggle } from './ToggleDescriptionTrafficNews';
import { initGalleryLightbox } from './TrafficNewsGallery';
import { initTrafficNewsBadge } from './TrafficNewsBadge';
import { Tracking } from './Tracking';
import { initImageHelper } from './ImageHelper';
jsCheck();
domReady(function () {
    let menu = initMenu();
    let searchToggler = initSearchToggler(menu);
    const lang = document.documentElement.lang ? document.documentElement.lang : 'de';
    const i18n = new I18n(lang);
    tabbingClass('is-tabbing');
    addRoleButtonListener();
    initParallax();
    // initZoomBanner();
    initNumberAnimation();
    initAnchorScroll();
    initExpandables();
    initCarousels();
    initSearchPage(searchToggler);
    initFilter(menu, searchToggler);
    formatAge();
    initImageHelper();
    initLikesCounter();
    initTeaserSliders();
    initVideos();
    initVideoiFrame();
    initColcades();
    initPlaylist();
    initWaterfall();
    initSocialmediaWall();
    initScrollTop();
    initScrollHeader();
    initMostViewed();
    initScrollEvents();
    initTrafficNewsFilter();
    initDescriptionToggle();
    initGalleryLightbox();
    initTrafficNewsBadge();
    initTrafficNewsRss();
    appendHintToExternalLinkTitles(i18n.getProperty('hint-external-link', ''));
    new Tracking();
    loadScript(getResourceUrl('js/lib/rcg-2019/rcg-2019.esm.js'), 'rcg-2019-module', null, 'module');
});
